import { Extension } from '@tiptap/core'

export default Extension.create({
    name: 'styles',

    addOptions() {
      return {
        types: ['paragraph'],
        styles: []
      }
    },
    
    addGlobalAttributes() {
      const attributes = {}
      const camelize = s => s.replace(/-./g, x=>x[1].toUpperCase())
      this.options.styles.map(s => {
        let camelized = camelize(s)
        attributes[camelized] = {
          default: null,
          parseHTML: el => el.style[camelized] || null,
          renderHTML: attrs => attrs[camelized] === null ? {} : { style: `${s}: ${attrs[camelized]}` }
        }
      })

      return [
        {
          types: this.options.types,
          attributes,
        },
      ]
    },
    
    // addCommands() {
    //   return {
    //     setBackgroundColor: (color) => ({ commands }) => {
    //       return this.options.types.every(type => commands.updateAttributes(type, { backgoundColor: color }))
    //     },
  
    //     unsetBackgroundColor: () => ({ commands }) => {
    //       return this.options.types.every(type => commands.resetAttributes(type, 'backgroundColor'))
    //     },
    //   }
    // },
})